import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { useBrand } from '../brand/BrandProvider';
import { BootstrapError } from './BootstrapError';

/**
 * Decision-router für `/`. Single Place für das Bootstrap-Redirect-Mapping —
 * vermeidet dass Leaf-Komponenten die gleiche Logik duplizieren.
 */
export function RootRedirect() {
  const auth = useAuth();
  const brand = useBrand();
  const location = useLocation();

  if (auth.status === 'loading') return null;
  if (auth.status === 'mfa-pending') return <Navigate to="/mfa-challenge" replace />;
  if (auth.status === 'anonymous') {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (brand.status === 'loading' || brand.status === 'idle') return null;
  if (brand.status === 'no-brands') return <Navigate to="/no-access" replace />;
  // Statt stillem Redirect zu /login — sichtbarer Fehler mit State-Inspector
  if (brand.status === 'error') return <BootstrapError />;

  if (brand.currentBrand) {
    return <Navigate to={`/${brand.currentBrand.slug}/dashboard`} replace />;
  }
  return <Navigate to="/no-access" replace />;
}
